import { combineReducers } from 'redux';

import manage from './manage';

export default combineReducers({
  manage,
});
